import {AdditionalInformationSection} from './AdditionalInformationSection'
import {ProductInformationSection} from './ProductInformationSection'
import {ReturnsDepositsSection} from './ReturnsDepositsSection'

export const BaseDataTab = () => {
  return (
    <div className="grid grid-cols-3 items-start gap-3">
      <ProductInformationSection />
      <ReturnsDepositsSection />
      <AdditionalInformationSection />
    </div>
  )
}
